import { useState } from "react";
import { Link } from "react-router-dom";
import { faqItems } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="h-1 w-6 bg-primary-500"></span>
            FAQ
          </p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于本站，你可能想问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们把读者最常问的几个问题整理在这里。如果还有疑问，欢迎通过投稿邮箱联系我们。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-customer-service-2-line"></i>
            </span>
            前往关于我们
          </Link>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqItems.map((item, index) => {
              const open = openIndex === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    aria-expanded={open}
                    className="flex w-full cursor-pointer items-start justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center text-foreground-500">
                      <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 pb-5 md:px-6">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}